import React, { useState, useEffect, useRef } from "react";
import { useTranslation, Trans } from "react-i18next";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Box from "@mui/system/Box";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled, useTheme } from "@mui/material/styles";
import { brandColors } from "../../../_components/brandedComponent/BrandedColors";
import Cookies from "universal-cookie";
import { LifeSafer, Monitech } from "../../../_helpers/BrandConstants";
import useMediaQuery from "@mui/material/useMediaQuery";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import ContactInfo from "../../../_components/steps/ContactInfo";
import { useForm } from "react-hook-form";
import DirectionsWalkIcon from "@mui/icons-material/DirectionsWalk";
import { useToaster } from "../../../_components/toaster/MuiToasterProvider";
import {
  registerEnrollee,
  enrolleeUpdate,
  saveEnrollee,
  clientUpdate,
  loadEnrollee,
  clientProfiles,
  generatePriceQuote,
  getPriceQuoteDetails,
} from "../../../_redux/actions/enrolleeActions";
import { loadStates } from "../../../_redux/actions/userActions";
import { utilities } from "@/_helpers";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import ReferralModal from "../../../_components/steps/modal/ReferralModal";
import ViolationInfo from "../../../_components/steps/ViolationInfo";
import VehicleInfo from "../../../_components/steps/VehicleInfos";
import CarIcon from "../../../_images/Car_Side.svg";
import AddressInfo from "../../../_components/steps/AddressInfo";
import {
  saveNewVehicle,
  loadVehicle,
} from "../../../_redux/actions/vehicleActions";
import { resetProfilePassword } from "../../../_api/usersApi";
import { enrolleeService } from "@/_services";
import IdInfo from "../../../_components/steps/IdInfo";
import PartnerPricingInfo from "../../../_components/steps/PartnerPricingInfo";
import LocationSchedule from "../../../_components/steps/LocationSchedule";
import MyAccount from "../../../_components/steps/MyAccount";
import ContinueButton from "../../../_components/steps/ContinueButton";
import { createAppointment } from "../../../_redux/actions/appointmentActions";
import { LanguageSelector } from "../../../_components/LanguageSelector";
import { Card, CardContent, Dialog } from "@mui/material";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import PhonelinkRingOutlinedIcon from "@mui/icons-material/PhonelinkRingOutlined";
import InActivityScreenBackground from "../../../_images/inActivityScreenBackground.png";
import mapIcon from "../../../_images/file_map_stack.png";
import garageCheckIcon from "../../../_images/garage_check.png";
import { USA } from "@/_helpers/CountryConstants";

const StyledCarIcon = styled("img")({
  // height: 28,
  height: 30,
  width: 30,
  marginTop: 8,
  filter: "invert(1)",
});

const deviceTypeMap = {
  1: "Ignition Interlock",
  5: "Portable",
  6: "Speed",
};

const PartnerStory = ({
  isLoaded,
  activeStep,
  setActiveStep,
  hasSetInitialStep,
  registerEnrollee,
  enrolleeUpdate,
  saveEnrollee,
  clientUpdate,
  loadEnrollee,
  saveNewVehicle,
  loadVehicle,
  generatePriceQuote,
  getPriceQuoteDetails,
  createAppointment,
  enrollee,
  statesList,
  loadStates,
}) => {
  const { t } = useTranslation();
  const cookies = new Cookies();
  const enrollmentCodeData = cookies.get("lsEnrollmentCode");
  // const partnerDisplayName =
  //   enrollmentCodeData?.partnerName ||
  //   enrollmentCodeData?.PartnerName ||
  //   enrollmentCodeData?.partner ||
  //   enrollmentCodeData?.Partner ||
  //   "Corporate";
  const siteCountryId = cookies.get("siteCountry") || USA;
  const theme = useTheme();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const isAbove1024 = useMediaQuery(theme.breakpoints.up(900));
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const partnerDiscountFallback =
    enrollmentCodeData?.partnerReferralDiscount ??
    enrollmentCodeData?.partnerDiscount ??
    enrollmentCodeData?.discountAmount ??
    null;
  const partnerPricingName =
    enrollmentCodeData?.partnerName ||
    enrollmentCodeData?.PartnerName ||
    enrollmentCodeData?.partner ||
    enrollmentCodeData?.Partner ||
    enrolleeUser?.partnerName ||
    enrolleeUser?.PartnerName ||
    enrolleeUser?.hearAboutName ||
    enrolleeUser?.HearAboutName;
  const isPartnerEnrollmentCode =
    (
      enrollmentCodeData?.enrollmentCodeType ??
      enrollmentCodeData?.EnrollmentCodeType ??
      enrollmentCodeData?.enrollmentcodeType
    )?.toLowerCase() === "partner";
  const isTruthyFlag = (value) =>
    value === true ||
    value === 1 ||
    String(value || "").toLowerCase() === "true" ||
    String(value || "") === "1";
  const isGenericPartnerWelcome = isTruthyFlag(
    enrollmentCodeData?.SkipIntro ??
      enrollmentCodeData?.skipIntro ??
      enrollmentCodeData?.skipintro ??
      enrollmentCodeData?.skip_intro,
  );
  let enrolleeDataArray = useRef([]);
  const [submitting, setSubmitting] = useState(false);
  const [pereferedContact, setPreferedContact] = useState(
    enrolleeUser?.contactPreference || "Phone",
  );
  const [referralModal, setReferralModal] = useState(false);
  const [isEnrolleeLoadNeeded, setIsEnrolleeLoadNeeded] = useState(false);
  const EnrollCookieData = cookies.get("EnrollNow") || {};
  const url = window.location.href;
  const isLifeSaferia = url.toLowerCase().includes("localhost");
  let clientSaveResponse = null;
  const [userData] = useState(null);

  const STEPS = {
    DEVICE: "DEVICE",
    LOCATION_MAP: "LOCATION_MAP",
    LOCATION_ZIP: "LOCATION_ZIP",
    PRICING: "PRICING",
    DATE_TIME: "DATE_TIME",
    SCHEDULE_NOW: "SCHEDULE_NOW",
  };

  const [stepSchedule, setStepSchedule] = useState(STEPS.SCHEDULE_NOW);
  const [flagDevice, setFlagDevice] = useState(false);
  const [quoteLoading, setQuoteLoading] = useState(false);
  const [priceQuote, setPriceQuote] = useState(null);
  const [deviceLocationType, setDeviceLocationType] = useState();
  const googleMapDataSession = JSON.parse(
    sessionStorage.getItem("googleMapData"),
  );
  const timer = useRef(null);
  const partnerVehicleResumeHandledRef = useRef(false);
  let timeout = 120000;
  const [openInactivityScreen, setOpenInactivityScreen] = useState(false); //a
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const setGoogleMapData = (mapData) => {
    sessionStorage.setItem("googleMapData", JSON.stringify(mapData));
  };

  const persistEnrolleeUser = (enrolleeUserData, forcedStep = null) => {
    const normalizedEnrolleeUser = { ...(enrolleeUserData || {}) };
    const resolvedStep =
      forcedStep ||
      normalizedEnrolleeUser?.Step ||
      normalizedEnrolleeUser?.step ||
      null;

    if (resolvedStep) {
      normalizedEnrolleeUser.Step = resolvedStep;
    } else {
      delete normalizedEnrolleeUser.Step;
    }

    delete normalizedEnrolleeUser.step;

    sessionStorage.setItem(
      "enrolleeUser",
      JSON.stringify(
        utilities.normalizeEnrolleeSessionData(normalizedEnrolleeUser),
      ),
    );
  };

  const withoutEnrollmentCodeFields = (data = {}) => {
    const cleanData = { ...data };
    delete cleanData.enrollmentCode;
    delete cleanData.enrollmentCodeId;
    delete cleanData.EnrollmentCodeId;
    delete cleanData.EnrollmentCodeID;
    return cleanData;
  };

  const StyledWalkingIcon = styled(DirectionsWalkIcon)({
    fontSize: isAbove1024 ? 24 : 20,
    marginTop: 2.6,
  });
  const toast = useToaster();
  const navigate = useNavigate();
  const jwtTokenData = cookies.get("lifesaferEnrollment");

  const resolveClientDeviceType = (clientTypeId) => {
    if (clientTypeId === 5) return "Portable";
    if (clientTypeId === 6) return "Speed";
    if (clientTypeId === 1) return "Interlock";
    return null;
  };

  useEffect(() => {
    loadStates(siteCountryId, brand).catch((error) => {
      console.error("Error loading states", error);
    });
  }, [siteCountryId, brand]);

  const {
    UTM_source,
    UTM_medium,
    UTM_campaign,
    GA_clientid,
    gclid,
    UserAgent,
    IPAddress,
    wbraid,
    gbraid,
    fbclid,
    fbp,
    ttclid,
    rdt_cid,
    Page: rawPage,
    URL,
  } = EnrollCookieData;

  const deviceType =
    deviceTypeMap[enrolleeUser?.clientTypeId] || "Ignition Interlock Device";
  const Page = rawPage?.substring(0, 150) || "";

  const resolveDeviceTypeValue = (...deviceCandidates) => {
    const explicitDeviceType = deviceCandidates.find(
      (value) => utilities?.deviceInfo(value)?.deviceType,
    );

    if (explicitDeviceType) {
      return utilities.deviceInfo(explicitDeviceType)?.deviceType || null;
    }

    return resolveClientDeviceType(enrolleeUser?.clientTypeId) || null;
  };
  const resolveLocalizedWelcomeDeviceType = () => {
    const resolvedDevice = utilities.deviceInfo(
      isLifeSaferia
        ? "Speed"
        : deviceLocationType ||
            enrolleeUser?.deviceType ||
            enrolleeUser?.clientTypeId,
    )?.device;

    if (resolvedDevice === "ISA") return t("steps.isaShort");
    if (resolvedDevice === "PAM") return t("steps.pamShort");
    return t("steps.iidShort");
  };
  const resolveCurrentDeviceInfo = () => {
    const currentSessionEnrollee =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};

    return utilities.deviceInfo(
      enrolleeDataArray?.current?.deviceType ||
        deviceLocationType ||
        currentSessionEnrollee?.deviceType ||
        currentSessionEnrollee?.clientTypeId ||
        enrolleeUser?.deviceType ||
        enrolleeUser?.clientTypeId,
    );
  };
  const isPamDeviceSelected = () =>
    resolveCurrentDeviceInfo()?.device === "PAM";

  let shouldSkipNextStep = false;

  const isPam = isPamDeviceSelected();
  const inactivityScreenDeviceType =
    deviceType?.toLowerCase() === "portable"
      ? "portable alcohol monitoring"
      : deviceType?.toLowerCase() === "speed"
        ? "intelligence speed assistance"
        : deviceType?.toLowerCase();

  const findState = (shortName) => {
    let retState = enrolleeUser?.state || "";
    let stateInfo = statesList?.filter((x) => x.shortName === shortName);
    if (stateInfo[0] !== undefined) {
      retState = stateInfo[0].name;
    }
    return retState;
  };

  const VEHICLE_STEP_INDEX = 3;
  const SCHEDULE_STEP_INDEX = 6;
  const LAST_STEP_INDEX = 7;
  const matchedStateName =
    findState(enrolleeUser?.state) || enrolleeUser?.state;
  const partnerStepsAtOrBeforeVehicle = [
    "welcome",
    "contact",
    "violation",
    "vehicle",
  ];

  const resolveQuoteDeviceType = () => {
    const currentDevice = resolveCurrentDeviceInfo()?.device;

    if (currentDevice === "PAM") {
      return "PAM";
    }

    if (currentDevice === "ISA") {
      return "ISA";
    }

    return "IID";
  };

  useEffect(() => {
    if (enrollee !== undefined && enrollee !== null) {
      const currentSessionEnrollee =
        JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
      sessionStorage.setItem(
        "enrolleeUser",
        JSON.stringify({
          ...currentSessionEnrollee,
          ...enrollee,
          HearAboutID:
            enrollee?.HearAboutID ??
            currentSessionEnrollee?.HearAboutID ??
            null,
          HearAboutName:
            enrollee?.HearAboutName ??
            currentSessionEnrollee?.HearAboutName ??
            null,
        }),
      );
    }
  }, [enrollee]);

  const toQuoteNumber = (value) => {
    if (value === null || value === undefined || value === "") return null;
    if (typeof value === "number") return Number.isFinite(value) ? value : null;
    const parsed = Number(String(value).replace(/[^0-9.-]/g, ""));
    return Number.isFinite(parsed) ? parsed : null;
  };

  const isInstallDescription = (description) =>
    String(description || "")
      .trim()
      .toLowerCase()
      .includes("install");

  const normalizeQuoteKey = (value) =>
    String(value || "")
      .replace(/[^a-z0-9]/gi, "")
      .toLowerCase();

  const isContractorOneTimeDescription = (description) => {
    const descriptionKey = normalizeQuoteKey(description);

    return (
      descriptionKey.includes("highend") ||
      descriptionKey.includes("calibration")
    );
  };

  const findQuoteNumberByKeys = (source, keys) => {
    if (!source || typeof source !== "object") return null;

    const sourceKeyMap = new Map(
      Object.keys(source).map((key) => [normalizeQuoteKey(key), source[key]]),
    );

    for (const key of keys) {
      const sourceValue = sourceKeyMap.get(normalizeQuoteKey(key));
      const quoteNumber = toQuoteNumber(sourceValue);

      if (quoteNumber !== null) {
        return quoteNumber;
      }
    }

    return null;
  };

  const summarizePriceQuoteDetails = (details) => {
    if (!Array.isArray(details) || details.length === 0) {
      return {
        oneTimeInstallationCost: null,
        biWeeklyProgramCost: null,
        programSubtotal: null,
        creditTotal: null,
      };
    }

    let oneTimeInstallationCost = 0;
    let biWeeklyProgramCost = 0;
    let creditTotal = 0;
    let hasOneTime = false;
    let hasProgram = false;
    let hasCredit = false;

    details.forEach((item) => {
      const invoiceItemType = String(
        item?.invoiceItemType || item?.InvoiceItemType || "",
      )
        .trim()
        .toUpperCase();
      const isInvoiceItem = invoiceItemType === "INVOICE";
      const isContractorItem = invoiceItemType === "CONTRACTOR";
      const isChargeItem = isInvoiceItem || isContractorItem;
      const description = item?.description || item?.Description;
      const itemTotal = toQuoteNumber(item?.total ?? item?.Total);

      if (itemTotal === null) return;

      if (invoiceItemType === "CREDIT") {
        creditTotal += itemTotal;
        hasCredit = true;
        return;
      }

      if (!isChargeItem) {
        return;
      }

      if (
        isInstallDescription(description) ||
        (isContractorItem && isContractorOneTimeDescription(description))
      ) {
        oneTimeInstallationCost += itemTotal;
        hasOneTime = true;
        return;
      }

      if (isInvoiceItem) {
        biWeeklyProgramCost += itemTotal;
        hasProgram = true;
      }
    });

    return {
      oneTimeInstallationCost: hasOneTime ? oneTimeInstallationCost : null,
      biWeeklyProgramCost: hasProgram ? biWeeklyProgramCost : null,
      programSubtotal: hasProgram ? biWeeklyProgramCost : null,
      creditTotal: hasCredit ? creditTotal : null,
    };
  };

  const normalizePartnerPriceQuote = (
    quoteResponse = {},
    quoteDetails = {},
  ) => {
    const quoteDetailBreakdown = summarizePriceQuoteDetails(
      quoteDetails?.priceQuoteDetails ||
        quoteDetails?.PriceQuoteDetails ||
        quoteResponse?.priceQuoteDetails ||
        quoteResponse?.PriceQuoteDetails,
    );
    const programSubtotal =
      quoteDetailBreakdown.programSubtotal ??
      findQuoteNumberByKeys(quoteDetails, [
        "subtotal",
        "subTotal",
        "programSubtotal",
        "programSubTotal",
      ]) ??
      findQuoteNumberByKeys(quoteResponse, [
        "subtotal",
        "subTotal",
        "programSubtotal",
        "programSubTotal",
      ]);
    const creditTotal =
      quoteDetailBreakdown.creditTotal ??
      findQuoteNumberByKeys(quoteDetails, [
        "creditTotal",
        "creditsTotal",
        "partnerReferralDiscount",
      ]) ??
      findQuoteNumberByKeys(quoteResponse, [
        "creditTotal",
        "creditsTotal",
        "partnerReferralDiscount",
      ]);
    const calculatedProgramCost =
      programSubtotal !== null ? programSubtotal : null;
    const installationCost =
      quoteDetailBreakdown.oneTimeInstallationCost ??
      quoteDetails?.laborChargesTotal ??
      quoteResponse?.laborChargesTotal ??
      quoteDetails?.installationCost ??
      quoteResponse?.installationCost;
    const biWeeklyProgramCost =
      calculatedProgramCost ??
      quoteDetails?.programCost ??
      quoteResponse?.programCost ??
      quoteDetails?.programCostBiWeekly ??
      quoteResponse?.programCostBiWeekly ??
      quoteDetails?.invoiceTotal ??
      quoteResponse?.invoiceTotal;
    const partnerReferralDiscount =
      creditTotal ??
      quoteDetails?.partnerReferralDiscount ??
      quoteResponse?.partnerReferralDiscount;

    return {
      ...(quoteResponse || {}),
      ...(quoteDetails || {}),
      installationCost,
      oneTimeInstallationCost: installationCost,
      onetimeinstallationcost: installationCost,
      programCost: biWeeklyProgramCost,
      programCostBiWeekly: biWeeklyProgramCost,
      biWeeklyProgramCost: biWeeklyProgramCost,
      partnerReferralDiscount,
    };
  };

  const resolveSessionVehicleId = (sessionEnrollee = {}) =>
    sessionEnrollee?.selectedVehicleID ||
    sessionEnrollee?.vehicleId ||
    sessionEnrollee?.VehicleId ||
    sessionEnrollee?.vehicleID ||
    sessionEnrollee?.VehicleID ||
    null;

  const resolveVehicleIdFromVehicle = (vehicle = {}) =>
    vehicle?.vehicleId ||
    vehicle?.VehicleId ||
    vehicle?.vehicleID ||
    vehicle?.VehicleID ||
    null;

  const normalizePartnerStep = (step) =>
    String(step || "")
      .replace(/\s+/g, "")
      .toLowerCase();

  const isResumedAfterPartnerVehicleStep = (step, currentActiveStep) => {
    const normalizedStep = normalizePartnerStep(step);

    if (normalizedStep) {
      return !partnerStepsAtOrBeforeVehicle.includes(normalizedStep);
    }

    return currentActiveStep > VEHICLE_STEP_INDEX;
  };

  const resolveConfirmedPartnerVehicleId = (sessionEnrollee = {}) => {
    const vehicleId = resolveSessionVehicleId(sessionEnrollee);
    if (!vehicleId || !sessionEnrollee?.partnerVehicleSelectionConfirmed) {
      return null;
    }

    return vehicleId;
  };

  const persistPartnerVehicleSelection = (
    sessionEnrollee = {},
    vehicle = {},
    forcedStep = null,
  ) => {
    const vehicleId = resolveVehicleIdFromVehicle(vehicle);
    if (!vehicleId) {
      return null;
    }

    const vehicleWithoutUserId = { ...vehicle };
    delete vehicleWithoutUserId.userId;

    persistEnrolleeUser(
      {
        ...sessionEnrollee,
        ...vehicleWithoutUserId,
        vehicleId,
        VehicleId: vehicleId,
        VehicleID: vehicleId,
        selectedVehicleID: vehicleId,
        partnerVehicleSelectionConfirmed: true,
      },
      forcedStep || sessionEnrollee?.Step || sessionEnrollee?.step || null,
    );

    return vehicleId;
  };

  const hydrateVehicleForQuote = async (sessionEnrollee = {}) => {
    const existingVehicleId = resolveSessionVehicleId(sessionEnrollee);
    if (
      existingVehicleId &&
      sessionEnrollee?.partnerVehicleSelectionConfirmed
    ) {
      return existingVehicleId;
    }

    const clientId = sessionEnrollee?.clientId || sessionEnrollee?.ClientId;
    const userId =
      sessionEnrollee?.userId ||
      sessionEnrollee?.UserId ||
      sessionEnrollee?.userID;

    if (!clientId || !userId) {
      return null;
    }

    try {
      const vehicleData = await loadVehicle(clientId, userId);
      const vehicles = Array.isArray(vehicleData)
        ? vehicleData.filter((vehicle) => resolveVehicleIdFromVehicle(vehicle))
        : [];

      if (vehicles.length === 0) {
        return null;
      }

      if (vehicles.length > 1) {
        return null;
      }

      return persistPartnerVehicleSelection(
        sessionEnrollee,
        vehicles[0],
        sessionEnrollee?.Step || sessionEnrollee?.step || null,
      );
    } catch (error) {
      return null;
    }
  };

  const loadPartnerPriceQuote = async (locationIdOverride = null) => {
    const currentSessionEnrollee =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
    const selectedLocation =
      JSON.parse(sessionStorage.getItem("locationFlag")) || null;
    const clientId =
      currentSessionEnrollee?.clientId || currentSessionEnrollee?.ClientId;
    const quoteDeviceType = resolveQuoteDeviceType();
    let vehicleId = resolveConfirmedPartnerVehicleId(currentSessionEnrollee);

    if (!vehicleId && quoteDeviceType !== "PAM") {
      vehicleId = await hydrateVehicleForQuote(currentSessionEnrollee);
    }

    const resolvedLocationId =
      locationIdOverride ||
      currentSessionEnrollee?.locationID ||
      currentSessionEnrollee?.LocationID ||
      currentSessionEnrollee?.locationId ||
      selectedLocation?.locationID ||
      null;

    if (!clientId || !resolvedLocationId) {
      setPriceQuote(null);
      return;
    }

    if (quoteDeviceType !== "PAM" && !vehicleId) {
      setPriceQuote(null);
      return;
    }

    setQuoteLoading(true);

    try {
      const quoteResponse = await generatePriceQuote({
        ClientID: clientId,
        VehicleID: vehicleId,
        DeviceType: quoteDeviceType,
        LocationID: resolvedLocationId,
        ContactMethod: "Text",
        // (pereferedContact || currentSessionEnrollee?.contactPreference || "")
        //   .toLowerCase()
        //   .trim() === "text"
        //   ? "Text"
        //   : "Text",
      });

      const priceQuoteGuid =
        quoteResponse?.priceQuoteGuid || quoteResponse?.PriceQuoteGuid || null;

      if (!priceQuoteGuid) {
        setPriceQuote(normalizePartnerPriceQuote(quoteResponse));
        return;
      }

      const quoteDetails = await getPriceQuoteDetails(priceQuoteGuid);
      const normalizedPartnerQuote = normalizePartnerPriceQuote(
        quoteResponse,
        quoteDetails,
      );

      setPriceQuote(normalizedPartnerQuote);
    } catch (error) {
      setPriceQuote(null);
    } finally {
      setQuoteLoading(false);
    }
  };

  const contactInfoForm = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      firstName: enrolleeUser?.firstName || enrolleeUser?.FirstName || null,
      lastName: enrolleeUser?.lastName || enrolleeUser?.LastName || null,
      cellPhone: enrolleeUser?.cellPhone || enrolleeUser?.CellPhone || null,
      email: enrolleeUser?.email || enrolleeUser?.Email,
      preferedContact: null,
      call_me_out: null,
    },
  });

  const welcomeSteps = isGenericPartnerWelcome
    ? [
        {
          title: t("partner.welcomeStepTitleOne"),
          description: isPam
            ? t("partner.welcomeStepDescriptionOnePam")
            : t("partner.genericWelcomeStepDescriptionOne"),
        },
        {
          title: t("partner.welcomeStepTitleTwo"),
          description: t("partner.welcomeStepDescriptionTwo"),
        },
        {
          title: t("partner.genericWelcomeStepTitleThree"),
          description: t("partner.genericWelcomeStepDescriptionThree"),
        },
      ]
    : [
        {
          title: t("partner.welcomeStepTitleOne"),
          description: isPam
            ? t("partner.welcomeStepDescriptionOnePam")
            : t("partner.welcomeStepDescriptionOne"),
        },
        {
          title: t("partner.welcomeStepTitleTwo"),
          description: t("partner.welcomeStepDescriptionTwo"),
        },
        {
          title: t("partner.welcomeStepTitleThree"),
          description: t("partner.welcomeStepDescriptionThree"),
        },
      ];

  const stepsInfo = [
    {
      name: "Welcome",
      step: 0,
      progressBarValue: 1,
      icon: null,
      title: t("partner.welcomeLifesafer"),
    },
    {
      name: "Contact",
      step: 1,
      progressBarValue: 10,
      icon: <StyledWalkingIcon />,
      title: t("steps.aboutYou"),
      description: t("partner.aboutPartner"),
    },
    {
      name: "Violation",
      step: 2,
      progressBarValue: 25,
      icon: <StyledWalkingIcon />,
      title: t("partner.programDetails"),
      description: t("partner.programDetailsPartnerDesp"),
    },
    {
      name: "Vehicle",
      step: 3,
      progressBarValue: 40,
      icon: isPam ? <StyledWalkingIcon /> : <StyledCarIcon src={CarIcon} />,
      title: t("steps.vehicleInfo"),
      description: t("partner.vehicleDescriptionPartner"),
    },
    {
      name: "Address",
      step: 4,
      progressBarValue: 55,
      icon: isPam ? <StyledWalkingIcon /> : <StyledCarIcon src={CarIcon} />,
      title: t("partner.homeAddress"),
      description: t("partner.addressDescriptionPartner"),
    },

    {
      name: "State",
      step: 5,
      progressBarValue: 70,
      icon: isPam ? <StyledWalkingIcon /> : <StyledCarIcon src={CarIcon} />,
      title: t("steps.stateId"),
      description: t("partner.idDescriptionPartner"),
    },
    {
      name: "Schedule",
      step: 6,
      progressBarValue: 85,
      icon: isPam ? <StyledWalkingIcon /> : <StyledCarIcon src={CarIcon} />,
      title: null,
      description: " ",
    },
    {
      name: "MyAccount",
      step: 7,
      progressBarValue: 100,
      icon: isPam ? <StyledWalkingIcon /> : <StyledCarIcon src={CarIcon} />,
      title: t("location.booked"),
      description: t("location.confirmationSent"),
    },
  ];

  const inactivityScreenStepLists = [
    {
      title: t("partner.inactivityScreenTitleOne"),
      description: t("partner.inactivityScreenDescriptionOne"),
      cardContent: [
        {
          icon: (
            <AssignmentTurnedInOutlinedIcon
              sx={{ width: "35px", height: "35px", color: "#1A355E" }}
            />
          ),
          description: (
            <Trans
              i18nKey="partner.inactivityScreenCardOne"
              components={{ strong: <strong /> }}
            />
          ),
        },
        {
          icon: (
            <HandshakeOutlinedIcon
              sx={{ width: "35px", height: "35px", color: "#1A355E" }}
            />
          ),
          description: (
            <Trans
              i18nKey="partner.inactivityScreenCardTwo"
              components={{ strong: <strong /> }}
            />
          ),
        },
      ],
    },
    {
      title: t("partner.inactivityScreenTitleTwo"),
      description: t("partner.inactivityScreenDescriptionTwo"),
      cardContent: [
        {
          icon: (
            <ThumbUpAltOutlinedIcon
              sx={{ width: "35px", height: "35px", color: "#1A355E" }}
            />
          ),
          description: (
            <Trans
              i18nKey="partner.inactivityScreenCardThree"
              components={{ strong: <strong /> }}
            />
          ),
        },
        {
          icon: (
            <PhonelinkRingOutlinedIcon
              sx={{ width: "35px", height: "35px", color: "#1A355E" }}
            />
          ),
          description: (
            <Trans
              i18nKey="partner.inactivityScreenCardFour"
              components={{ strong: <strong /> }}
            />
          ),
        },
      ],
    },

    {
      title: t("partner.inactivityScreenTitleThree"),
      description: t("partner.inactivityScreenDescriptionThree", {
        deviceType: inactivityScreenDeviceType,
      }),
      cardContent: [
        {
          icon: (
            <img
              src={mapIcon}
              style={{ width: "35px", height: "35px", color: "#1A355E" }}
            />
          ),
          description: (
            <Trans
              i18nKey="partner.inactivityScreenCardFive"
              components={{ strong: <strong /> }}
              values={{ matchedStateName }}
            />
          ),
        },
        {
          icon: (
            <img
              src={garageCheckIcon}
              style={{ width: "35px", height: "35px", color: "#1A355E" }}
            />
          ),
          description: (
            <Trans
              i18nKey="partner.inactivityScreenCardSix"
              components={{ strong: <strong /> }}
              values={{ matchedStateName, deviceType }}
            />
          ),
        },
      ],
    },
  ];
  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    events.forEach((event) => window.addEventListener(event, handleActivity));

    startTimer(); // start initially

    return () => {
      clearTimeout(timer.current);
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity),
      );
    };
  }, [activeStep]);

  const startTimer = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      if (activeStep >= 1 && activeStep <= 5) {
        setOpenInactivityScreen(true);
      } else {
        setOpenInactivityScreen(false);
      }
    }, timeout);
  };

  const handleActivity = () => {
    startTimer();
  };

  const goToBackStep = () => {
    if (activeStep > 0) {
      const previousStepValue =
        activeStep === 4 && isPamDeviceSelected() ? 2 : 1;
      setActiveStep((previousStep) =>
        Math.max(previousStep - previousStepValue, 0),
      );
    }
  };

  const goToNextStep = () => {
    let nextStepValue = 1;
    // if pam skip vehicle
    if (activeStep === 2 && isPamDeviceSelected()) {
      nextStepValue = 2;
    }
    setActiveStep((previousStep) =>
      Math.min(previousStep + nextStepValue, LAST_STEP_INDEX),
    );
  };

  useEffect(() => {
    if (
      partnerVehicleResumeHandledRef.current ||
      activeStep <= VEHICLE_STEP_INDEX ||
      resolveQuoteDeviceType() === "PAM"
    ) {
      return;
    }

    const currentSessionEnrollee =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
    const persistedStep =
      currentSessionEnrollee?.Step || currentSessionEnrollee?.step;

    if (!isResumedAfterPartnerVehicleStep(persistedStep, activeStep)) {
      return;
    }

    if (resolveConfirmedPartnerVehicleId(currentSessionEnrollee)) {
      partnerVehicleResumeHandledRef.current = true;
      return;
    }

    const clientId =
      currentSessionEnrollee?.clientId || currentSessionEnrollee?.ClientId;
    const userId =
      currentSessionEnrollee?.userId ||
      currentSessionEnrollee?.UserId ||
      currentSessionEnrollee?.userID;

    if (!clientId || !userId) {
      partnerVehicleResumeHandledRef.current = true;
      return;
    }

    let isMounted = true;

    loadVehicle(clientId, userId)
      .then((vehicleData) => {
        if (!isMounted) return;

        const vehicles = Array.isArray(vehicleData)
          ? vehicleData.filter((vehicle) =>
              resolveVehicleIdFromVehicle(vehicle),
            )
          : [];

        if (vehicles.length > 1) {
          partnerVehicleResumeHandledRef.current = true;
          setPriceQuote(null);
          setActiveStep(VEHICLE_STEP_INDEX);
          return;
        }

        if (vehicles.length === 1) {
          persistPartnerVehicleSelection(
            currentSessionEnrollee,
            vehicles[0],
            persistedStep,
          );
        }

        partnerVehicleResumeHandledRef.current = true;
      })
      .catch(() => {
        partnerVehicleResumeHandledRef.current = true;
      });

    return () => {
      isMounted = false;
    };
  }, [activeStep, loadVehicle, setActiveStep]);

  useEffect(() => {
    if (activeStep !== SCHEDULE_STEP_INDEX || quoteLoading || priceQuote) {
      return;
    }

    const currentSessionEnrollee =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
    const selectedLocation =
      JSON.parse(sessionStorage.getItem("locationFlag")) || null;
    const locationId =
      currentSessionEnrollee?.locationID ||
      currentSessionEnrollee?.LocationID ||
      currentSessionEnrollee?.locationId ||
      selectedLocation?.locationID ||
      null;

    if (!locationId) {
      return;
    }

    loadPartnerPriceQuote(locationId);
  }, [activeStep, priceQuote]);

  useEffect(() => {
    if (activeStep < 5 || resolveQuoteDeviceType() === "PAM") {
      return;
    }

    const currentSessionEnrollee =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
    const hasVehicleId = resolveConfirmedPartnerVehicleId(
      currentSessionEnrollee,
    );

    if (hasVehicleId) {
      return;
    }

    hydrateVehicleForQuote(currentSessionEnrollee);
  }, [activeStep]);

  useEffect(() => {
    sessionStorage.setItem("partnerStoryUiStep", String(activeStep ?? 0));
    window.dispatchEvent(new Event("partnerStepUpdated"));
  }, [activeStep]);

  useEffect(() => {
    if (isEnrolleeLoadNeeded === true && jwtTokenData?.jwtToken) {
      const reloadEnrollee = async () => {
        const currentSessionEnrollee =
          JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
        if (
          currentSessionEnrollee?.clientId !== undefined &&
          currentSessionEnrollee?.userId !== undefined
        ) {
          try {
            const enrolleeData = await loadEnrollee(
              currentSessionEnrollee?.clientId,
              currentSessionEnrollee?.userId,
            );

            if (enrolleeData) {
              persistEnrolleeUser({
                ...currentSessionEnrollee,
                ...enrolleeData,
                HearAboutID:
                  enrolleeData?.HearAboutID ??
                  currentSessionEnrollee?.HearAboutID ??
                  null,
                HearAboutName:
                  enrolleeData?.HearAboutName ??
                  currentSessionEnrollee?.HearAboutName ??
                  null,
                homeAddr1:
                  enrolleeData?.homeAddr1 ??
                  currentSessionEnrollee?.homeAddr1 ??
                  null,
                city:
                  enrolleeData?.city ?? currentSessionEnrollee?.city ?? null,
                state:
                  enrolleeData?.state ?? currentSessionEnrollee?.state ?? null,
                zip: enrolleeData?.zip ?? currentSessionEnrollee?.zip ?? null,
                homeLat:
                  enrolleeData?.homeLat ??
                  currentSessionEnrollee?.homeLat ??
                  null,
                homeLong:
                  enrolleeData?.homeLong ??
                  currentSessionEnrollee?.homeLong ??
                  null,
                deviceType:
                  enrolleeData?.clientTypeId === 5
                    ? "Portable"
                    : enrolleeData?.clientTypeId === 6
                      ? "Speed"
                      : "Interlock",
              });

              if (enrolleeData?.contactPreference) {
                setPreferedContact(enrolleeData?.contactPreference);
              }
            }
          } catch (error) {
            console.error(error);
          } finally {
            setIsEnrolleeLoadNeeded(false);
          }
        }
      };

      reloadEnrollee();
    }
  }, [isEnrolleeLoadNeeded]);

  const handleReferalSubmit = () => {
    const storedEnrolleeUser =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
    const { isReferralModalSubmit, ...cleanEnrolleeUser } = storedEnrolleeUser;

    if (isReferralModalSubmit) {
      persistEnrolleeUser(cleanEnrolleeUser);
    }

    setReferralModal(false);
    goToNextStep();
  };

  const handleUpdate = async (currentStep, updateData) => {
    if (currentStep === "Referral") {
      handleReferalSubmit();
      return;
    }
    if (updateData) {
      setSubmitting(true);
    }

    if (currentStep === "Violation" && updateData && isPartnerEnrollmentCode) {
      updateData = withoutEnrollmentCodeFields(updateData);
    }

    enrolleeDataArray.current = {
      ...enrolleeDataArray.current,
      ...updateData,
    };

    const currentEnrolleeUser =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || enrolleeUser || {};
    const enrolleeID =
      currentEnrolleeUser?.enrolleeId ||
      currentEnrolleeUser?.EnrolleeId ||
      enrolleeUser?.enrolleeId ||
      enrolleeUser?.EnrolleeId;
    const userId =
      currentEnrolleeUser?.userId ||
      currentEnrolleeUser?.UserId ||
      enrolleeUser?.userId ||
      enrolleeUser?.UserId;
    const clientId =
      currentEnrolleeUser?.clientId ||
      currentEnrolleeUser?.ClientId ||
      enrolleeUser?.clientId ||
      enrolleeUser?.ClientId;
    const jwtToken = jwtTokenData?.jwtToken;
    try {
      if (enrolleeID && jwtToken) {
        const enrolleData = {
          ...updateData,
          enrolleeId: enrolleeID,
          story: "Partner",
          Step: currentStep === "PartnerPricing" ? "Schedule" : currentStep,
          contactPreference: pereferedContact || "Phone",
          deviceType:
            resolveDeviceTypeValue(
              updateData?.deviceType,
              deviceLocationType,
              enrolleeUser?.deviceType,
            ) || "Interlock",
          utM_source: UTM_source || null,
          utM_medium: UTM_medium || null,
          utM_campaign: UTM_campaign || null,
          gA_clientid: GA_clientid || null,
          gclID: gclid || null,
          userAgent: UserAgent || null,
          ipAddress: IPAddress || null,
          wbraid: wbraid || null,
          gbraid: gbraid || null,
          fbclid: fbclid || null,
          fbp: fbp || null,
          ttclid: ttclid || null,
          rdt_cid: rdt_cid || null,
          page: Page || null,
          referURL: URL?.slice(0, 500) || null,
        };
        await enrolleeUpdate(enrolleData);
      }

      if (currentStep === "PartnerPricing") {
        persistEnrolleeUser(
          {
            ...currentEnrolleeUser,
            story: "Partner",
          },
          "Schedule",
        );
        return;
      }

      if (updateData?.isReferralModalSubmit && clientId) {
        const referralSessionData =
          JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
        const preservedReferralFields = {
          HearAboutID:
            updateData?.HearAboutID ?? referralSessionData?.HearAboutID ?? null,
          HearAboutName:
            updateData?.HearAboutName ??
            referralSessionData?.HearAboutName ??
            null,
        };
        const referralClientUpdate = {
          ...referralSessionData,
          ...preservedReferralFields,
          ...updateData,
          ClientId: clientId,
          UserId: userId,
          EnrolleeId: enrolleeID,
          BrandIdentifier:
            updateData?.BrandIdentifier ||
            referralSessionData?.BrandIdentifier ||
            brand,
          CellPhone:
            updateData?.CellPhone ||
            referralSessionData?.CellPhone ||
            referralSessionData?.cellPhone ||
            null,
          HomePhone:
            updateData?.HomePhone ||
            referralSessionData?.HomePhone ||
            referralSessionData?.homePhone ||
            null,
          Email:
            updateData?.Email ||
            referralSessionData?.Email ||
            referralSessionData?.email ||
            null,
          FirstName:
            updateData?.FirstName ||
            referralSessionData?.FirstName ||
            referralSessionData?.firstName ||
            null,
          LastName:
            updateData?.LastName ||
            referralSessionData?.LastName ||
            referralSessionData?.lastName ||
            null,
          contactPreference: pereferedContact || "Phone",
          story: "Partner",
        };
        await clientUpdate(referralClientUpdate);
      }

      switch (currentStep) {
        case "Contact":
          try {
            const storedContactSessionData =
              JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
            const preservedContactFields = {
              HearAboutID:
                updateData?.HearAboutID ??
                storedContactSessionData?.HearAboutID ??
                null,
              HearAboutName:
                updateData?.HearAboutName ??
                storedContactSessionData?.HearAboutName ??
                null,
            };

            if (!enrolleeID || !jwtToken) {
              const contactUpdateData = {
                ...preservedContactFields,
                ...updateData,
              };

              await registerEnrollee(contactUpdateData).then(
                async (enrolleeRes) => {
                  cookies.set(
                    "lifesaferEnrollment",
                    JSON.stringify(enrolleeRes),
                    {
                      path: "/",
                      sameSite: "strict",
                    },
                  );
                  let enrolleeData = {
                    ...contactUpdateData,
                    enrolleeId: enrolleeRes?.enrolleeId,
                    clientId: enrolleeRes?.clientId,
                    story: "Partner",
                    Step: currentStep,
                    utM_source: UTM_source || null,
                    utM_medium: UTM_medium || null,
                    utM_campaign: UTM_campaign || null,
                    gA_clientid: GA_clientid || null,
                    gclID: gclid || null,
                    userAgent: UserAgent || null,
                    ipAddress: IPAddress || null,
                    wbraid: wbraid || null,
                    gbraid: gbraid || null,
                    fbclid: fbclid || null,
                    fbp: fbp || null,
                    ttclid: ttclid || null,
                    rdt_cid: rdt_cid || null,
                    page: Page || null,
                    referURL: URL?.slice(0, 500) || null,
                  };

                  if (!enrolleeRes?.jwtToken) {
                    persistEnrolleeUser(enrolleeRes, currentStep);

                    if (["TEXT", "EMAIL"].includes(enrolleeRes?.resetSent)) {
                      shouldSkipNextStep = true;
                      return navigate("/verify", {
                        state: {
                          enrollee: enrolleeRes,
                          lifeSaferUser: contactUpdateData,
                        },
                      });
                    }

                    if (enrolleeRes?.resetSent === "CALL") {
                      shouldSkipNextStep = true;
                      return navigate("/contact-page");
                    }
                  }

                  await enrolleeUpdate(enrolleeData);
                  let clientSaveUpdateData = {
                    ...contactUpdateData,
                    UserId: enrolleeRes?.userId,
                    EnrolleeId: enrolleeRes?.enrolleeId,
                  };
                  if (
                    !utilities.isMissingOrDefaultEnrollmentCode(
                      enrollmentCodeData,
                    )
                  ) {
                    clientSaveResponse =
                      await saveEnrollee(clientSaveUpdateData);
                  }

                  let enrolleeSessionUpdateData = {
                    userId: enrolleeRes?.userId,
                    enrolleeId: enrolleeRes?.enrolleeId,
                    clientId: clientSaveResponse?.clientId,
                    Step: currentStep,
                    story: "Partner",
                  };

                  enrolleeSessionUpdateData = {
                    ...enrolleeSessionUpdateData,
                    ...contactUpdateData,
                  };

                  persistEnrolleeUser(enrolleeSessionUpdateData, currentStep);
                },
              );
            } else {
              const contactUpdateData = {
                ...preservedContactFields,
                ...updateData,
              };

              let clientUpdateData = {
                ...contactUpdateData,
                UserId: userId,
                EnrolleeId: enrolleeID,
                ClientId: clientId,
                Step: currentStep,
                story: "Partner",
              };

              updateData = {
                ...contactUpdateData,
                UserId: userId,
                EnrolleeId: enrolleeID,
                ClientId: clientId,
                ...{ story: "Partner" },
              };
              const sessionUpdateData = { ...updateData };
              delete sessionUpdateData.isReferralModalSubmit;

              persistEnrolleeUser(
                {
                  ...currentEnrolleeUser,
                  ...sessionUpdateData,
                },
                currentStep,
              );

              if (clientId) {
                await clientUpdate(clientUpdateData);
              }
            }

            setReferralModal(updateData?.isReferralModalSubmit ? false : true);
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }

          break;

        case "Violation":
          try {
            const storedEnrolleeUser =
              JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
            const referralFields = {
              HearAboutID:
                storedEnrolleeUser?.HearAboutID ?? updateData?.HearAboutID,
              HearAboutName:
                storedEnrolleeUser?.HearAboutName ?? updateData?.HearAboutName,
            };

            if (!clientId) {
              if (
                utilities.isMissingOrDefaultEnrollmentCode(enrollmentCodeData)
              ) {
                let contactInfoFormValue = contactInfoForm.watch();
                let newContactInfoData = {
                  Step: "Violation",
                  firstName: contactInfoFormValue.firstName,
                  lastName: contactInfoFormValue.lastName,
                  homePhone: contactInfoFormValue.cellPhone,
                  email: contactInfoFormValue.email,
                  contactPreference: pereferedContact || "Phone",
                  BrandIdentifier: brand,
                  CellPhone: contactInfoFormValue.cellPhone,
                  // deviceType: deviceType || "IID",
                  EnrolleeId: enrolleeUser?.enrolleeId,
                  story: "Partner",
                };

                updateData = {
                  ...updateData,
                  ...newContactInfoData,
                };
              }
              await saveEnrollee(updateData).then(async (enrolleeResponse) => {
                let newData = {
                  ...referralFields,
                  ...updateData,
                  clientId:
                    enrolleeResponse?.ClientId || enrolleeResponse?.clientId,
                  userId: enrolleeResponse?.UserId || enrolleeResponse?.userId,
                  contactPreference: pereferedContact || "Phone",
                  story: "Partner",
                };

                await clientUpdate(newData);
                if (
                  utilities.isMissingOrDefaultEnrollmentCode(
                    enrollmentCodeData,
                  )
                ) {
                  let enrolleeSessionUpdateData = {
                    userId:
                      enrolleeResponse?.userId || enrolleeResponse?.userId,
                    enrolleeId:
                      enrolleeResponse?.enrolleeId ||
                      enrolleeResponse?.EnrolleeId,
                    clientId:
                      enrolleeResponse?.clientId || enrolleeResponse?.ClientId,
                  };

                  persistEnrolleeUser(
                    {
                      ...storedEnrolleeUser,
                      ...enrolleeSessionUpdateData,
                      HearAboutID:
                        referralFields?.HearAboutID ??
                        storedEnrolleeUser?.HearAboutID ??
                        null,
                      HearAboutName:
                        referralFields?.HearAboutName ??
                        storedEnrolleeUser?.HearAboutName ??
                        null,
                    },
                    currentStep,
                  );
                }
              });
            } else {
              updateData = {
                ...referralFields,
                ...updateData,
                contactPreference: pereferedContact || "Phone",
                story: "Partner",
              };

              await clientUpdate(updateData);
            }
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }
          break;

        case "Vehicle":
          try {
            if (!updateData) {
              const selectedVehicleSession =
                JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
              const selectedVehicleId = resolveSessionVehicleId(
                selectedVehicleSession,
              );

              if (selectedVehicleId) {
                persistEnrolleeUser(
                  {
                    ...selectedVehicleSession,
                    vehicleId: selectedVehicleId,
                    VehicleId: selectedVehicleId,
                    VehicleID: selectedVehicleId,
                    selectedVehicleID: selectedVehicleId,
                    partnerVehicleSelectionConfirmed: true,
                  },
                  currentStep,
                );
              }

              break;
            }
            const result = await saveNewVehicle(updateData);
            if (result) {
              const vehicleData = await loadVehicle(clientId, userId);

              const normalizedResult = String(result);
              const matchedVehicle = vehicleData?.find((x) => {
                const candidateId = resolveVehicleIdFromVehicle(x);
                return String(candidateId) === normalizedResult;
              });

              if (matchedVehicle) {
                const vehicleWithoutUserId = { ...matchedVehicle };
                delete vehicleWithoutUserId.userId;
                persistEnrolleeUser(
                  {
                    ...currentEnrolleeUser,
                    ...updateData,
                    ...vehicleWithoutUserId,
                    vehicleId: result,
                    VehicleId: result,
                    VehicleID: result,
                    selectedVehicleID: result,
                    partnerVehicleSelectionConfirmed: true,
                  },
                  currentStep,
                );
              } else {
                persistEnrolleeUser(
                  {
                    ...currentEnrolleeUser,
                    ...updateData,
                    vehicleId: result,
                    VehicleId: result,
                    VehicleID: result,
                    selectedVehicleID: result,
                    partnerVehicleSelectionConfirmed: true,
                  },
                  currentStep,
                );
              }
            }
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return false;
          }
          break;

        case "Address":
          updateData = {
            ...updateData,
            Step: currentStep,
            contactPreference: pereferedContact || "Phone",
            story: "Partner",
          };
          try {
            await clientUpdate(updateData);
            persistEnrolleeUser(
              {
                ...currentEnrolleeUser,
                ...updateData,
              },
              currentStep,
            );
            if (updateData?.zip) {
              sessionStorage.setItem("zipCode", String(updateData.zip));
            }
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }

          break;

        case "Id":
          updateData = {
            ...updateData,
            Step: currentStep,
            contactPreference: pereferedContact || "Phone",
            story: "Partner",
          };
          try {
            await clientUpdate(updateData);
            persistEnrolleeUser(
              {
                ...currentEnrolleeUser,
                ...updateData,
              },
              currentStep,
            );
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }

          break;
        case "Schedule":
          updateData = {
            ...updateData,
            contactPreference: pereferedContact || "Phone",
            story: "Partner",
             deviceType:
              enrolleeUser?.deviceType === "Interlock" ||
              enrolleeUser?.clientTypeId === 1
                ? "IID"
                : enrolleeUser?.deviceType === "Portable" ||
                    enrolleeUser?.clientTypeId === 5
                  ? "PAM"
                  : enrolleeUser?.deviceType === "Speed" ||
                      enrolleeUser?.clientTypeId === 6
                    ? "ISA"
                    : "IID",
          };

          try {
            const newAppointment = await createAppointment(updateData);

            if (newAppointment?.appointmentID > 0) {
              sessionStorage.setItem(
                "appointmentData",
                JSON.stringify({
                  ...updateData,
                  appointmentID: newAppointment.appointmentID,
                }),
              );

              const enrolleeDeviceType =
                resolveDeviceTypeValue(
                  updateData?.deviceType,
                  deviceLocationType,
                  currentEnrolleeUser?.deviceType,
                  enrolleeUser?.deviceType,
                ) || "Interlock";

              await enrolleeUpdate({
                ...currentEnrolleeUser,
                ...updateData,
                enrolleeId: enrolleeID,
                clientId: clientId,
                Step: "MyAccount",
                complete: true,
                deviceType: enrolleeDeviceType,
              });

              let updatedSessionData = {
                ...currentEnrolleeUser,
                hasAppointment: true,
                Step: "MyAccount",
                deviceType: enrolleeDeviceType,
              };

              persistEnrolleeUser(updatedSessionData, "MyAccount");

              toast.success(t("outro.apptSaveSuccess"));
            }
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }

          break;
        case "MyAccount":
          try {
            await resetProfilePassword(
              updateData?.userID || enrolleeUser?.userId,
              updateData?.password,
            );
            let emailObj = {
              emailAddress: enrolleeUser.email,
              brandIdentifier: brand === Monitech ? "monitechiid" : brand,
              silent: true,
            };
            enrolleeService
              .sendVerifyCode(emailObj)
              .then((message) => {
                cookies.remove("lifesaferEnrollment", { path: "/" });
                cookies.remove("lsEnrollmentError", { path: "/" });
                cookies.remove("lsEnrollmentCode", { path: "/" });
                cookies.remove("lifesaferRedirect", { path: "/" });
                cookies.remove("lifesaferLockout", { path: "/" });
                cookies.remove("lifesaferMailer", { path: "/" });
                cookies.remove("EnrollNow", { path: "/" });
                sessionStorage.removeItem("enrolleeUser");
                window.location.replace(
                  process.env.CP_URL +
                    "/account/transfer/" +
                    message +
                    "-" +
                    enrolleeUser.userId +
                    "-" +
                    enrolleeUser.clientId,
                );
              })
              .catch(() => {
                console.log("Failed to retrieve auth.");
                window.location.replace(process.env.CP_URL + "/account/login");
              });
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }
          break;
        default:
          console.warn(`Unknown step "${currentStep}"`);
      }
      hasSetInitialStep.current = true;
      if (
        !(
          currentStep === "Contact" &&
          utilities.isMissingOrDefaultEnrollmentCode(enrollmentCodeData)
        )
      ) {
        setIsEnrolleeLoadNeeded(true);
      }
      if (currentStep === "Contact") {
        if (shouldSkipNextStep) {
          return;
        }

        if (updateData?.isReferralModalSubmit) {
          goToNextStep();
        }
        return;
      }
      if (!shouldSkipNextStep) {
        goToNextStep();
      }
    } catch (error) {
      let errMess = error.message
        ?.split(":")
        .pop()
        ?.replace('"', "")
        ?.slice(0, -2);
      toast.error(t("toasts.updateFailed") + " " + errMess);
    } finally {
      setSubmitting(false);
    }
  };

  const InActivityScreen = () => {
    let inactivityScreenStep;

    if (activeStep <= 2) {
      inactivityScreenStep = 0;
    } else if (activeStep <= 4) {
      inactivityScreenStep = 1;
    } else {
      inactivityScreenStep = 2;
    }

    return (
      <Dialog
        open={openInactivityScreen}
        onClose={handleInactivityClose}
        maxWidth={false}
        className="modal_container"
        fullScreen={isMobile}
        sx={{
          "	.MuiDialog-backdrop": {
            display: isMobile ? "none" : "block",
          },
        }}
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: 740 },
            maxWidth: "100%",
            overflow: "hidden",
            boxShadow: "0 32px 80px rgba(0,0,0,0.22)",
            height: { xs: "calc(100vh - 57px)", sm: 640 },
            // height:"calc(100vh - 57px)",
            m: 0,
            position: "fixed",
            bottom: { xs: 0, sm: "auto" },
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: "relative",
            overflow: "hidden",
            height: { xs: "240px", sm: "280px" },

            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,

              backgroundImage: `
              linear-gradient(
                rgba(0, 20, 70, 0.45),
                rgba(0, 20, 70, 0.45)
              ),
              url(${InActivityScreenBackground})
          `,

              backgroundSize: "105%",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            },

            pt: { xs: "40px", sm: "52px" },
            px: { xs: "24px", sm: "48px" },
            pb: { xs: "72px", sm: "80px" },

            "& > *": {
              position: "relative",
              zIndex: 1400,
            },
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              // backgroundImage:
              //   "linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)",
              backgroundSize: "36px 36px",
            }}
          />
          <Box
            component="svg"
            viewBox="0 0 740 220"
            preserveAspectRatio="none"
            sx={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
            }}
          >
            <line
              x1="0"
              y1="100"
              x2="300"
              y2="0"
              stroke="rgba(255,255,255,0.07)"
              strokeWidth="1.5"
            />
            <line
              x1="740"
              y1="80"
              x2="420"
              y2="220"
              stroke="rgba(255,255,255,0.07)"
              strokeWidth="1.5"
            />
            <line
              x1="100"
              y1="220"
              x2="600"
              y2="0"
              stroke="rgba(255,255,255,0.05)"
              strokeWidth="1"
            />
            <line
              x1="500"
              y1="220"
              x2="740"
              y2="40"
              stroke="rgba(255,255,255,0.04)"
              strokeWidth="1"
            />
          </Box>

          <Box
            sx={{
              position: "relative",
              zIndex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Typography
              align="center"
              sx={{
                color: "#fff",
                fontWeight: 700,
                fontSize: { xs: "22px", sm: "26px" },
                lineHeight: 1.3,
                mb: 1.5,
                letterSpacing: "-0.3px",
              }}
            >
              {inactivityScreenStepLists[inactivityScreenStep]?.title}
            </Typography>
            <Typography
              align="center"
              sx={{
                color: "rgba(255,255,255,0.75)",
                fontSize: { xs: "13px", sm: "15px" },
                lineHeight: 1.6,
                px: { xs: 1, sm: 0 },
              }}
            >
              {inactivityScreenStepLists[inactivityScreenStep]?.description}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            px: { xs: "16px", sm: "48px" },
            display: "flex",
            flexDirection: "column",
            gap: 2,
            mt: { xs: "-60px", sm: "-80px" },
            position: "relative",
            zIndex: 2,
            bgcolor: "transparent",
            alignItems: "center",
          }}
        >
          {inactivityScreenStepLists[inactivityScreenStep]?.cardContent?.map(
            (x, i) => (
              <Card
                key={i}
                elevation={2}
                sx={{
                  bgcolor: "#EDF2FB",
                  borderRadius: "14px",
                  width: { xs: "100%", sm: "450px" },
                  mt: 1,
                }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    p: {
                      xs: "20px 20px !important",
                      sm: "28px 32px !important",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 56,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-end",
                    }}
                  >
                    {x?.icon}
                  </Box>
                  <Typography
                    align="center"
                    sx={{
                      color: "#3a4a6b",
                      lineHeight: 1.6,
                      fontSize: { xs: "13px", sm: "15px" },
                      mt: 1,
                    }}
                  >
                    {x?.description}
                  </Typography>
                </CardContent>
              </Card>
            ),
          )}
          {inactivityScreenStep === 1 && (
            <>
              <Typography
                sx={{
                  mt: 1,
                  color: "#596E8D",
                  fontSize: { xs: "13px", sm: "15px" },
                }}
              >
                {t("partner.inactivityScreenNote")}
              </Typography>
            </>
          )}
        </Box>

        <Box
          sx={{
            px: { xs: "16px", sm: "48px" },
            pt: { xs: "20px", sm: "28px" },
            pb: { xs: "24px", sm: "36px" },
            bgcolor: "#fff",
            display: "flex",
            justifyContent: "center",
            mt: "auto",
          }}
        >
          <Button
            fullWidth
            variant="contained"
            onClick={handleInactivityClose}
            sx={{
              bgcolor: "#75BE43",
              color: "#213F5C",
              borderRadius: "10px",
              fontSize: { xs: "12px", sm: "13px" },
              fontWeight: 700,
              py: { xs: 1.6, sm: 1.8 },
              width: { xs: "100%", sm: "400px" },
              "&:hover": { bgcolor: "#63a835" },
            }}
          >
            {t("partner.continueEnrollment")}
          </Button>
        </Box>
      </Dialog>
    );
  };

  const handleInactivityClose = () => {
    setOpenInactivityScreen(false);
    startTimer();
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 15,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: "#eeeeee",
      ...theme.applyStyles("dark", {
        backgroundColor: "#eeeeee",
      }),
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 40,
      backgroundColor: `${brandColors[brand].secondary}`,
      ...theme.applyStyles("dark", {
        backgroundColor: `${brandColors[brand].secondary}`,
      }),
    },
  }));

  const Welcome = () => {
    return (
      <Grid
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: isMobile ? 0 : 2,
          flexDirection: "column",
          padding: isMobile ? "24px" : "0px",
          paddingTop: isMobile ? "0px" : "auto",
        }}
      >
        {isGenericPartnerWelcome ? (
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: { xs: "left", sm: "center" },
              gap: "4px",
            }}
          >
            <Typography>{t("partner.genericWelcomeIntroOne")}</Typography>
            <Typography>{t("partner.genericWelcomeIntroTwo")}</Typography>
          </Grid>
        ) : (
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              // textAlign: "center",
              textAlign: { xs: "left", sm: "center" },
              gap: "4px",
            }}
          >
            <Typography>
              {t("partner.welcomeTitleOne", {
                partnerName: partnerPricingName,
                deviceType: resolveLocalizedWelcomeDeviceType(),
              })}{" "}
              <br />
            </Typography>
            <Typography>{t("partner.welcomeTitleTwo")}</Typography>

            <Typography sx={{ display: { xs: "inline", sm: "none" } }}>
              {t("partner.welcomeTitleThree")}
            </Typography>

            <Typography sx={{ display: { xs: "none", sm: "inline" } }}>
              {t("partner.welcomeTitleThree")}
            </Typography>
          </Grid>
        )}

        <Grid
          sx={{
            marginTop: "24px",
            marginLeft: "8px",
            width: "fit-content",
          }}
        >
          <Grid
            sx={{
              display: { xs: "inline" },
            }}
          >
            <Typography
              sx={{
                marginBottom: 2,
                fontWeight: "bold",
              }}
            >
              {isGenericPartnerWelcome
                ? t("partner.genericWelcomeTakeCareTitle")
                : t("partner.welcomeTitleFive")}
            </Typography>
          </Grid>

          {welcomeSteps.map((step, index) => (
            <Grid
              key={index}
              sx={{
                display: "flex",
                gap: "12px",
                marginBottom: "16px",
              }}
            >
              <TaskAltIcon sx={{ color: "#75BE43" }} />
              <Box>
                <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
                  {step.title}
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "14px",
                    marginBottom:index===2?"30px" : "0px"
                   }}
                >
                  {step.description}
                </Typography>
              </Box>
            </Grid>
          ))}

          <Grid sx={{ mt: 2, width: "100%" }}>
            <ContinueButton
              onClick={() => setActiveStep(1)}
              continueText={
                isGenericPartnerWelcome
                  ? "location.getStarted"
                  : "intro.step2ButtonLabel"
              }
              submitting={submitting}
              continueButtonShow
              isFullLeftRightWidth
            />
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const StepsHeader = ({ title, description }) => {
    if (!title && !description) return null;

    let welcomeStyle = {
      width: "100%",
      textAlign: { xs: "left", sm: "center" },
      paddingLeft: isMobile ? "24px" : "0px",
    };
    return (
      <Grid
        sx={{
          mt: 2,
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {title ? (
          <Typography
            variant="h5"
            sx={{
              // color: `${brandColors[brand].primaryLight}`,
              color: "#4b9CD3",
              fontWeight: 600,
              ...(activeStep === 0 ? welcomeStyle : {}),
            }}
          >
            {title}
          </Typography>
        ) : null}
        {description ? (
          <Typography sx={{ textAlign: "center", mt: 1 }}>
            {description}
          </Typography>
        ) : null}
      </Grid>
    );
  };

  StepsHeader.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return <Welcome />;
      case 1:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <ContactInfo
                setSubmitting={setSubmitting}
                submitting={submitting}
                goToBackStep={goToBackStep}
                contactInfoForm={contactInfoForm}
                pereferedContact={pereferedContact}
                setPreferedContact={setPreferedContact}
                handleUpdate={handleUpdate}
                isLoaded={isLoaded}
                activeStep={activeStep}
              />
            </Grid>
          </>
        );
      case 2:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <ViolationInfo
                setSubmitting={setSubmitting}
                submitting={submitting}
                goToBackStep={goToBackStep}
                handleUpdate={handleUpdate}
              />
            </Grid>
          </>
        );
      case 3:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <VehicleInfo
                setSubmitting={setSubmitting}
                submitting={submitting}
                goToBackStep={goToBackStep}
                handleUpdate={handleUpdate}
                goToNextStep={goToNextStep}
              />
            </Grid>
          </>
        );

      case 4:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <AddressInfo
                setSubmitting={setSubmitting}
                submitting={submitting}
                goToBackStep={goToBackStep}
                handleUpdate={handleUpdate}
                userData={userData}
              />
            </Grid>
          </>
        );
      case 5:
        return (
          <>
            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <IdInfo
                setSubmitting={setSubmitting}
                submitting={submitting}
                goToBackStep={goToBackStep}
                handleUpdate={handleUpdate}
              />
            </Grid>
          </>
        );
      case 6:
        return (
          <>
            <Grid
              sx={{ display: "flex", justifyContent: "center", width: "100%" }}
            >
              <LocationSchedule
                submitting={submitting}
                handleUpdate={handleUpdate}
                setActiveStep={setActiveStep}
                setDeviceLocationType={setDeviceLocationType}
                deviceLocationType={deviceLocationType}
                isLoaded={isLoaded}
                STEPS={STEPS}
                stepSchedule={stepSchedule}
                setStepSchedule={setStepSchedule}
                setGoogleMapData={setGoogleMapData}
                flagDevice={flagDevice}
                setFlagDevice={setFlagDevice}
                googleMapDataSession={googleMapDataSession}
                flagClickReset={false}
                compactScheduleFlow
                pricing
                forceLocationSelectionEachEntry
                onEnterPricing={(location) =>
                  loadPartnerPriceQuote(location?.locationID)
                }
                renderPricingStep={({ onContinue }) => (
                  <Grid sx={{ display: "flex", flexDirection: "column" }}>
                    <Grid
                      sx={{
                        mt: 2,
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          // color: `${brandColors[brand].primaryLight}`,
                          color: "#4b9CD3",
                          fontWeight: 600,
                        }}
                      >
                        {t("partnerPricing.allSetTitle")}
                      </Typography>
                      <Typography
                        sx={{
                          textAlign: "center",
                          mt: 1,
                          width: {
                            xs: "90%",
                            sm: "90%",
                            md: "65%",
                          },
                        }}
                      >
                        {t("partnerPricing.allSetDescription", {
                          partnerName: partnerPricingName,
                        })}
                      </Typography>
                    </Grid>

                    <Grid
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <PartnerPricingInfo
                        loading={quoteLoading}
                        quote={priceQuote}
                        onScheduleAppointment={onContinue}
                        partnerDiscountFallback={partnerDiscountFallback}
                        partnerName={partnerPricingName}
                        handleUpdate={handleUpdate}
                      />
                    </Grid>
                  </Grid>
                )}
              />
            </Grid>
          </>
        );
      case 7:
        return (
          <>
            <Grid
              sx={{ display: "flex", justifyContent: "center", width: "100%" }}
            >
              <MyAccount submitting={submitting} handleUpdate={handleUpdate} />
            </Grid>
          </>
        );
    }
  };

  return (
    <Grid sx={{ padding: activeStep === 0 ? "0px" : "24px" }}>
      <InActivityScreen />

      <ReferralModal
        setReferralModal={setReferralModal}
        referralModal={referralModal}
        goToNextStep={goToNextStep}
        handleUpdate={handleUpdate}
        pereferedContact={pereferedContact}
        STEPS={STEPS}
        setStepSchedule={setStepSchedule}
        setActiveStep={setActiveStep}
        setFlagDevice={setFlagDevice}
        handleReferalSubmit={handleReferalSubmit}
      />

      {activeStep > 0 &&
        stepsInfo[activeStep] &&
        stepsInfo[activeStep].progressBarValue && (
          <Grid
            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Box
              sx={{
                position: "relative",
                width: isAbove1024 ? "80%" : "100%",
                // mt: 2,
              }}
            >
              <BorderLinearProgress
                variant="determinate"
                value={stepsInfo[activeStep].progressBarValue}
                // color="success"
                sx={{ height: isAbove1024 ? "36px" : "25px", borderRadius: 10 }}
              />
              <Typography
                variant="body2"
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: {
                    // xs: `${stepsInfo[activeStep].progressBarValue - 4}%`,
                    // sm: `${stepsInfo[activeStep].progressBarValue - 1.4}%`,
                    xs: `${
                      stepsInfo[activeStep].progressBarValue - (isPam ? 4 : 6)
                    }%`, // Mobile
                    sm: `${
                      stepsInfo[activeStep].progressBarValue -
                      (isPam ? 2.5 : 4.5)
                    }%`, // Small tablets (600px+)
                    md: `${
                      stepsInfo[activeStep].progressBarValue -
                      (isPam ? 1.4 : 1.8)
                    }%`, // Tablets/Laptops (900px+)
                  },
                  transform: "translate(-50%, -50%)",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  color: "white",
                }}
              >
                {stepsInfo[activeStep].icon}
              </Typography>
            </Box>
          </Grid>
        )}

      {activeStep === 0 && (
        <>
          <Grid
            sx={{
              backgroundColor: "#1A355E",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "60px",
              px: 1,
            }}
          >
            <VerifiedUserOutlinedIcon sx={{ color: "white", flexShrink: 0 }} />
            <Typography
              sx={{
                color: "white",
                marginLeft: "6px",
              }}
            >
              {isGenericPartnerWelcome
                ? t("partner.genericTrustedBanner")
                : t("partner.referedToLifeSafer", {
                    partnerName: partnerPricingName,
                  })}
            </Typography>
          </Grid>
          {isAbove1024 ? (
            <Box sx={{ display: "flex", justifyContent: "end", mr: 2 }}>
              <LanguageSelector />
            </Box>
          ) : null}
        </>
      )}

      {stepsInfo[activeStep === 9 ? activeStep - 1 : activeStep] && (
        <StepsHeader
          title={
            stepsInfo[activeStep === 9 ? activeStep - 1 : activeStep].title
          }
          description={
            stepsInfo[activeStep === 9 ? activeStep - 1 : activeStep]
              .description
          }
        />
      )}

      {renderStepContent(activeStep)}
    </Grid>
  );
};

const mapDispatchToProps = {
  registerEnrollee,
  enrolleeUpdate,
  saveEnrollee,
  clientUpdate,
  loadEnrollee,
  clientProfiles,
  saveNewVehicle,
  loadVehicle,
  generatePriceQuote,
  getPriceQuoteDetails,
  createAppointment,
  loadStates,
};

function mapStateToProps(state) {
  return {
    enrollee: state.enrollee,
    statesList: state.statesList,
  };
}

PartnerStory.propTypes = {
  registerEnrollee: PropTypes.func,
  enrollee: PropTypes.object.isRequired,
  enrolleeUpdate: PropTypes.func,
  saveEnrollee: PropTypes.func,
  clientUpdate: PropTypes.func,
  loadEnrollee: PropTypes.func,
  saveNewVehicle: PropTypes.func,
  loadVehicle: PropTypes.func,
  generatePriceQuote: PropTypes.func,
  getPriceQuoteDetails: PropTypes.func,
  createAppointment: PropTypes.func,
  setActiveStep: PropTypes.func,
  hasSetInitialStep: PropTypes.bool,
  activeStep: PropTypes.number,
  clientProfiles: PropTypes.func,
  isLoaded: PropTypes.bool,
  statesList: PropTypes.array,
  loadStates: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerStory);
